import z from "zod";

import handleErrorResponse from "@/lib/handle-error-response";
import { actionClient } from "@/lib/safe-action";
import { objToCamelCase } from "@/lib/utils";
import fetcher from "@/lib/fetcher";

export const fetchLiveClasses = actionClient
  .inputSchema(
    z.object({
      startDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
      endDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
      status: z.string().optional(),
    })
  )
  .action(async ({ clientInput: { startDate, endDate, status = "1,2,3" } }) => {
    const response = await fetcher(
      "/api/app-content-ws/api/v2/schedule/getCalendarLiveClass",
      { params: { startDate, endDate, status } }
    );

    if (!response.ok) return handleErrorResponse(response);

    const data = await response.json();
    if (data.status === 200) return objToCamelCase(data.liveClasses);

    return null;
  });

export const subscribeToClassNotification = actionClient
  .inputSchema(
    z.object({
      courseId: z.number(),
      subscribe: z.boolean(),
    })
  )
  .action(async ({ clientInput: { courseId, subscribe } }) => {
    const response = await fetcher(
      "/api/liveclass-ws/v1/live-class/notification/save/status",
      {
        method: "POST",
        body: JSON.stringify({ courseId, isActive: subscribe }),
      }
    );

    if (!response.ok) return handleErrorResponse(response);

    const data = await response.json();
    if (data.success) return true;

    return null;
  });
